module.exports = __webpack_public_path__ + "img/green.32897b33.png";